import { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Accordion from 'react-bootstrap/Accordion';
import { FaBook } from "react-icons/fa";

import PageHero from "../components/PageHero";

const Resources = () => {
    const [activeKey, setActiveKey] = useState(null);

    const resources = [
        {
            id: '0',
            title: 'Getting Started Guide',
            content: `Welcome to our platform! This guide will help you get started with creating and managing
            your podcast clubs. Learn the basics of setting up your profile, inviting members, and scheduling episodes.`
        },
        {
            id: '1',
            title: 'Best Practices for Podcast Clubs',
            content: `Discover proven strategies for running successful podcast clubs. Topics include engagement
            techniques, discussion facilitation, and ways to keep your members active and interested.`
        },
        {
            id: '2',
            title: 'Technical Documentation',
            content: `Detailed technical documentation for advanced features. Learn about RSS feed integration,
            episode scheduling, custom skills creation, and analytics tracking.`
        },
        {
            id: '3',
            title: 'Community Guidelines',
            content: `Our community guidelines help maintain a positive and productive environment. Review the
            rules for respectful communication, content standards, and member interaction expectations.`
        },
        {
            id: '4',
            title: 'FAQ & Troubleshooting',
            content: `Find answers to frequently asked questions and solutions to common issues. Topics include
            account management, billing questions, technical support, and feature requests.`
        }
    ];

    return (
        <div id="Resources-component">

            {/* ── Hero ── */}
            <PageHero>
                <div className="d-flex align-items-center gap-3">
                    <FaBook size={32} style={{ opacity: 0.9 }} />
                    <div>
                        <h1 className="page-hero__title mb-1">Resources</h1>
                        <p className="page-hero__sub mb-0">
                            Guides, documentation and tips to get the most out of Podsy.
                        </p>
                    </div>
                </div>
            </PageHero>

            {/* ── Content ── */}
            <div className="container-lg py-4 px-3 px-lg-4">
                <Row>
                    <Col sm={12}>
                        <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                            {resources.map((resource) => (
                                <Accordion.Item eventKey={resource.id} key={resource.id}>
                                    <Accordion.Header>{resource.title}</Accordion.Header>
                                    <Accordion.Body>
                                        <p>{resource.content}</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </div>

        </div>
    );
};

export default Resources;
